import {Injectable} from '@angular/core';
import {HttpClient} from '../../common/http.client';
import {environment} from 'environments/environment';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {MvtService} from '../../common/services/mvt.service';

@Injectable()
export class InformoService extends MvtService {
    private __alertLevel: number;
    // @ts-ignore
    getAlertLevel: BehaviorSubject<number> = new BehaviorSubject<number>(this.__alertLevel);

    constructor(protected http: HttpClient) {
        super(http);
    }

    updateAlertLevel(level) {
        this.__alertLevel = level;
        this.getAlertLevel.next(this.__alertLevel);
    }

    searchRoute(params) {
        return this.http.post(`${environment.api}/madrid/routing`, params).map(response => {
            return response.json();
        });
    }

    searchGeocoding(query) {
        return this.http.get(`${environment.api}/madrid/geocoding`, {
            params: {
                search: query
            }
        }).map(response => {
            const geometry = response.json();
            if (!geometry) {
                return null;
            }
            return {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        properties: {
                            coords: geometry.coordinates
                        },
                        geometry: geometry
                    }]
            };
        });
    }

    searchPlate(plate: string) {
        return this.http.get(`${environment.platesAPI}?plate=${plate}`).map(response => {
            return response.json();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/informo.service.ts